import { behindJumpRegister } from "./behindJump";
import { operationLogRegister } from "./operationLog";
import { registerResourceDataDownload } from './data-download'

export default {
  behindJumpRegister,
  operationLogRegister,
  registerResourceDataDownload
}
